import React from "react";
import styled from "styled-components";
import Portimga1 from "../assets/Cat.png";
import Portimga2 from "../assets/PortImage2.png";
import Portimga3 from "../assets/Icon-1024x1024 2 (1).png";
import Portimga4 from "../assets/PortImage4.png";
import Portimga5 from "../assets/PortImage5.png";
import Portimga6 from "../assets/PortImage6.png";
import Portimga7 from "../assets/PortImage7.png";
import Portimga8 from "../assets/Group 211.png";
import Portimga9 from "../assets/PortImage9.png";
import Portimga10 from "../assets/PortImage10.png";
import Portimga11 from "../assets/dog new icon 1 (1).png";
import Portimga12 from "../assets/Icon-1024x1024 1 (1).png";
import Portimga13 from "../assets/Car-Parking-Icon-1024x1024 1.png";
import Portimga14 from "../assets/icon 2 1.png";
import Portimga15 from "../assets/5 14 (1).png";
import Portimga16 from "../assets/4 (1) 1 (1).png";
import Portimga17 from "../assets/icon 2qq 1.png";
import Portimga18 from "../assets/icon (6) 1 (1).png";
import Portimga19 from "../assets/Icon1 1 (1).png";
import Portimga20 from "../assets/Group 212.png";
import Portimga21 from "../assets/icon 2 2 (1).png";
import Portimga22 from "../assets/Icon 1 1 (1).png";
import Portimga23 from "../assets/image_2022_01_28T12_18_24_284Z 1 (1).png";
import Portimga24 from "../assets/Group 202.png";
import Portimga25 from "../assets/icon 334 (1).png";
import Portimga26 from "../assets/Candy Cup 1 (1).png";
import Portimga27 from "../assets/cat-icon 1 (4).png";
import Portimga28 from "../assets/Group 216.png";
import Portimga29 from "../assets/Group 215.png";
import Portimga30 from "../assets/image 121 (1).png";
import Portimga31 from "../assets/cedverv 1 (1).png";
import { IoGameControllerOutline } from "react-icons/io5";

const MainContanier = styled.div`
  margin: 0px;
  padding: 0px;
  /* background-color: red; */
  box-sizing: border-box;
`;
const PortfolioSection = styled.h1`
  align-items: center;
  text-align: center;
  font-size: 60px;
  margin: 30px;

  @media screen and (max-width: 600px) {
    font-size: 32px;
  }
  @media screen and (min-width: 601px) and (max-width: 1024px) {
    font-size: 32px;
  }
`;
const PortfolioPara = styled.p`
  align-items: center;
  text-align: center;
  font-size: 20px;
  /* font-weight: bold; */
  margin: 40px;

  @media screen and (max-width: 600px) {
    font-size: 18px;
  }
  @media screen and (min-width: 601px) and (max-width: 1024px) {
    font-size: 18px;
    line-height: 1.6;
  }
`;
const GameLinks1 = styled.div`
  max-width: 50%;
  max-height: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;
  text-align: center;
  align-items: center;
  justify-content: center;
  /* display: flex; */
  display: flex;
  // margin-top: 10px;
  flex-direction: row;
  gap: 10px;
  top: 0px;
  left: 0px;
  /* background-color: yellow; */

  @media screen and (max-width: 600px) {
    flex-direction: column;
    max-width: 100%;
    height: auto;
    /* padding-right:10px ; */
  }
  @media screen and (min-width: 601px) and (max-width: 1024px) {
    max-width: 100%;
    height: auto;
    /* padding-right:10px ; */
  }
  @media screen and (min-width: 1025px) and (max-width: 1300px) {
    max-width: 100%;
    height: auto;
    /* padding-right:10px ; */
    padding-left: 10px;
  }
  @media screen and (min-width: 1301px) and (max-width: 1440px) {
    gap: 10px;
    padding-left: 30px;
    //  padding-right: 30px;
  }
  @media (min-width: 1441px) and (max-width: 1700px) {
    gap: 0px;
    padding-left: 60px;
    //  padding-right: 30px;
  }
  @media (min-width: 1701px) and (max-width: 2200px) {
    gap: 20px;
    padding-left: 60px;
    //  padding-right: 30px;
  }
`;
const GameLinks5 = styled.div`
  max-width: 50%;
  max-height: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;
  text-align: center;
  align-items: center;
  justify-content: center;
  /* display: flex; */
  display: flex;
  margin-top: 10px;
  flex-direction: row;
  gap: 10px;
  top: 0px;
  left: 0px;
  /* background-color: yellow; */

  @media screen and (max-width: 600px) {
    flex-direction: column;
    max-width: 100%;
    height: auto;
    padding-right: 10px;
  }
  @media screen and (min-width: 601px) and (max-width: 1024px) {
    max-width: 100%;
    height: auto;
    padding-right: 10px;
  }
  @media screen and (min-width: 1025px) and (max-width: 1300px) {
    max-width: 100%;
    height: auto;
  }
  @media screen and (min-width: 1701px) and (max-width: 2200px) {
  }
`;
const GameLinks2 = styled.div`
  max-width: 50%;
  max-height: 100%;
  margin-top: 10px;
  box-sizing: border-box;
  flex-wrap: wrap;
  text-align: center;
  /* margin-right: 20px; */
  align-items: center;
  justify-content: center;
  /* display: flex; */
  display: flex;
  flex-direction: row;
  gap: 10px;
  top: 0px;
  left: 0px;
  /* background-color: #e9193c; */

  @media screen and (max-width: 600px) {
    flex-direction: column;
    max-width: 100%;
    height: auto;
    margin-right: 10px;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    /* flex-direction: column; */
    max-width: 100%;
    height: auto;
    margin-right: 10px;
  }

  @media (min-width: 1025px) and (max-width: 1300px) {
    display: flex;
    max-width: 100%;
    // margin-right:130px;
    // margin-left: 130px;
  }
  @media (min-width: 1301px) and (max-width: 1440px) {
    padding-right: 30px;
  }
  @media (min-width: 1441px) and (max-width: 1700px) {
    padding-right: 60px;
  }
  @media (min-width: 1701px) and (max-width: 2200px) {
    padding-right: 60px;
  }
`;
const GameLinks = styled.div`
  max-width: 100%;
  max-height: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;
  /* display: flex; */
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  margin-top: 10px;
  gap: 10px;
  top: 0px;
  left: 0px;
  /* background-color: pink; */
  @media screen and (max-width: 600px) {
    margin-left: 5px;
  }

  @media (min-width: 1701px) and (max-width: 2200px) {
    margin-left: 20px;
  }
`;
const CardImage = styled.img`
  position: relative;
  /* width: 100%; */

  top: 10px;
  left: 10px;
  object-fit: cover;
  /* border-radius: 0px 25px 40px 20px; */
  /* box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); Box shadow */
  /* transition: transform 0.3s ease, box-shadow 0.3s ease; Smooth transition for hover effects */

  /* &:hover { */
  /* transform: scale(1.05); Slight zoom effect on hover */
  /* box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);  */
  /* } */
  @media (max-width: 600px) {
    width: 370px;
    /* margin: 10px; */
    height: 370px;
  }

  @media screen and (min-width: 1025px) and (max-width: 1300px) {
    width: 230px;
    height: auto;
  }
  @media screen and (min-width: 1331px) and (max-width: 1440px) {
  }
  @media (min-width: 1441px) and (max-width: 1700px) {
  }
  @media (min-width: 1701px) and (max-width: 2200px) {
    width: 420px;
    height: auto;
  }
`;

const CardImage1 = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  margin: auto;
  @media screen and (min-width: 1025px) and (max-width: 1300px) {
    width: 1000px;
    height: auto;
  }
  @media screen and (min-width: 1331px) and (max-width: 1440px) {
    width: 620px;
    height: auto;
  }
  @media (min-width: 1441px) and (max-width: 1700px) {
    width: 620px;
    height: auto;
  }
  @media (min-width: 1701px) and (max-width: 2200px) {
    width: 870px;
    height: auto;
    margin-top: 10px;
  }
`;

const Card = styled.div`
  position: relative;
  overflow: hidden;
  cursor: pointer;
`;

const Gellary = styled.div`
  width: 100%;
  height: 100%;
  gap: 10px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  /* background-color: #16bd69; */
  display: flex;
  /* padding-left: 35px; */

  @media screen and (max-width: 600px) {
    flex-direction: column;
    padding-left: 0px;
    gap: 0px;
  }
  @media screen and (min-width: 601px) and (max-width: 1024px) {
    flex-direction: column;
    /* padding-left: 0px; */
    gap: 0px;
  }
  @media screen and (min-width: 1025px) and (max-width: 1300px) {
    flex-direction: column;
    /* padding-left: 0px; */
  }
  @media screen and (min-width: 1331px) and (max-width: 1440px) {
    gap: 0px;
  }
  @media (min-width: 1441px) and (max-width: 1700px) {
    gap: 0px;
  }
  @media (min-width: 1701px) and (max-width: 2200px) {
    gap: 0px;
    // padding-left:60px;
  }
`;
const Gellary9 = styled.div`
  width: 100%;
  height: 100%;
  gap: 10px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  /* background-color: #16bd69; */
  display: flex;
  /* padding-left: 35px; */

  @media screen and (max-width: 600px) {
    flex-direction: column;
    padding-left: 0px;
    gap: 0px;
  }
  @media screen and (min-width: 601px) and (max-width: 1024px) {
    flex-direction: column;
    /* padding-left: 0px; */
    gap: 0px;
  }
  @media screen and (min-width: 1025px) and (max-width: 1300px) {
    flex-direction: column;
    /* padding-left: 0px; */
  }
  @media screen and (min-width: 1331px) and (max-width: 1440px) {
    gap: 0px;
    padding-left: 20px;
  }
  @media (min-width: 1441px) and (max-width: 1700px) {
    gap: 0px;
  }
  @media (min-width: 1701px) and (max-width: 2200px) {
    gap: 0px;
    padding-left: 60px;
  }
`;
const Gellary1 = styled.div`
  width: 100%;
  height: 100%;
  /* gap:10px; */
  box-sizing: border-box;
  /* background-color: #6b6363; */
  display: flex;
  margin-left: 15px;
  @media screen and (max-width: 600px) {
    flex-direction: column;
    padding-left: 0px;
    margin-left: 0%;
  }
  @media screen and (min-width: 601px) and (max-width: 1024px) {
    flex-direction: column;
    padding-left: 0px;
    margin-left: 0%;
  }
  @media screen and (min-width: 1025px) and (max-width: 1300px) {
    flex-direction: column;
    margin-left: 0%;
  }
  @media screen and (min-width: 1301) and (max-width: 1440px) {
    display: flex;
  }

  @media (min-width: 1441px) and (max-width: 1700px) {
    display: flex;
  }
  @media (min-width: 1701px) and (max-width: 2200px) {
    display: flex;
  }
`;

const AppSection = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
`;

const GamesHeader = styled.h1`
  color: white;
  text-decoration: none;
  margin-top: 60px;
  top: 0%;
  left: 0%;
`;
const GamesHeader1 = styled.h1`
  color: white;
  text-decoration: none;
  margin-top: 60px;
  font-size: 22px;
  top: 0%;
  left: 0%;
`;
const GamesButton = styled.button`
  padding: 10px 18px;
  font-size: 20px;
  /* margin-top:20px; */
  background-color: rgba(0, 0, 0, 0.6);
  color: #ee0d0d;
  border: none;
  cursor: pointer;
  margin-top: 20px;
  font-weight: bold;
  border-radius: 5px;
  border: solid 1px white;
  margin-bottom: 20px;
  text-decoration: none;
  te &:hover {
    background-color: #e03e35;
  }
`;
const GamesButton12 = styled.button`
  padding: 10px 20px;
  font-size: 30px;
  /* margin-top:20px; */
  background-color: white;
  color: #ee0d0d;
  border: none;
  cursor: pointer;
  margin-top: 20px;
  font-weight: bold;
  border-radius: 5px;
  border: solid 1px white;
  margin-bottom: 20px;
  text-decoration: none;
  te &:hover {
    background-color: #e03e35;
  }
`;

const Bottonref = styled.div`
  margin-top: 100px;
  margin-right: 10px;
`;
const Bottonref12 = styled.div`
  margin-top: 200px;
  margin-right: 10px;
`;
const Div4 = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  flex-direction: column;
  opacity: 0;
  transition: opacity 0.6s ease;
  margin-top: 10px;
  margin-left: 10px;
  &:hover {
    opacity: 1;
    border-radius: 10px;
    margin-top: 10px;
    margin-left: 10px;
  }
`;
const Div45 = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  flex-direction: column;
  opacity: 0;
  transition: opacity 0.6s ease;

  &:hover {
    opacity: 1;
    border-radius: 10px;
  }
`;
const StyledGameControllerIcon = styled(IoGameControllerOutline)`
  color: #fc0202; /* Set the color of the icon */
  font-size: 40px; /* Adjust the size of the icon */
  margin-right: 8px; /* Add space between the icon and the text */
  transition: transform 0.3s ease;
  text-align: center;
  align-items: center;
  padding-top: 10px;

  &:hover {
    transform: scale(1.2); /* Scale the icon slightly on hover */
  }
`;
const StyledGameControllerIcon1 = styled(IoGameControllerOutline)`
  color: white; /* Set the color of the icon */
  font-size: 20px; /* Adjust the size of the icon */
  margin-right: 8px; /* Add space between the icon and the text */
  transition: transform 0.3s ease;
  text-align: center;
  align-items: center;
  justify-content: center;
`;
const CardImage2 = styled.img`
  width: 100%;
  height: 100%;
  padding-top: 10px;
  padding-left: 10px;
  @media screen and (min-width: 1025px) and (max-width: 1300px) {
    width: 1000px;
    height: auto;
  }
  @media screen and (min-width: 1700px) and (max-width: 2200px) {
    width: 870px;
    height: auto;
    // margin-left: 60px;
  }
`;
const CardImage3 = styled.img`
  width: 100%;
  height: 100%;
  padding-top: 10px;
  padding-left: 10px;
  @media screen and (min-width: 1025px) and (max-width: 1300px) {
    width: 1000px;
    height: auto;
  }
  @media screen and (min-width: 1301px) and (max-width: 1440) {
    max-width: 670px;
    height: auto;
  }
  @media (min-width: 1441px) and (max-width: 1700px) {
    max-width: 670px;
    height: auto;
  }
  @media (min-width: 1701px) and (max-width: 2200px) {
    width: 870px;
    height: auto;
  }
`;

const ClassImage = styled.div`
  position: relative;
  cursor: pointer;
`;
const HeadPlusPeera = styled.div`
  box-sizing: border-box;
  margin: 0%;
  padding: 0%;
  align-items: center;
  text-align: center;
`;

const MainSection = styled.div``;
const GamePortfolio = () => {
  const PortfolioImage1 = [
    {
      img: Portimga1,
      Discription: "My virtual pet Cat Games",
      link: "https://apps.apple.com/us/app/my-virtual-pet-cat-games/id1606711438",
    },
  ];
  const PortfolioImage2 = [
    {
      img: Portimga2,
      Discription: "Animal Simulator: Pet Games 3D",
      link: "https://apps.apple.com/us/app/animal-simulator-pet-games-3d/id1626834550",
    },
    {
      img: Portimga3,
      Discription: "World war army strike 3D",
      link: "https://apps.apple.com/us/app/world-war-army-strike-3d/id1600019171",
    },
    {
      img: Portimga4,
      Discription: "Quad Bike Repair simulation",
      link: "https://play.google.com/store/apps/details?id=com.mrbunn.quad.bike.repair.saloon",
    },
    {
      img: Portimga5,
      Discription: "Horse Riding Simulator Game ",
      link: "https://apps.apple.com/us/app/horse-riding-animal-simulator/id1641715257",
    },
  ];
  const PortfolioImage3 = [
    {
      img: Portimga6,
      Discription: "Car Sale Car Dealership Game",
      link: "https://apps.apple.com/us/app/car-sale-car-dealership-game/id6476617041",
    },
    {
      img: Portimga7,
      Discription: "GT Gangsters Crime stories",
      link: "https://apps.apple.com/us/app/gt-gangsters-crime-stories/id6479355043",
    },
    {
      img: Portimga8,
      Discription: "Chocolate Cake making games",
      link: "https://play.google.com/store/apps/details?id=com.mrbunn.chocolate.cake.baking.game.comfy.cake.factory",
    },
    {
      img: Portimga9,
      Discription: "Burger bun shop Burger cooking",
      link: "https://play.google.com/store/apps/details?id=com.mrbunn.best.burger.bun.shop.humburger.patties.factory",
    },
  ];
  const PortfolioImage4 = [
    {
      img: Portimga10,
      Discription: "Duck Game Bird Simulator",
      link: "https://apps.apple.com/us/app/duck-game-bird-simulator/id6446163054",
    },
    {
      img: Portimga11,
      Discription: "My virtual dog simulator",
      link: "https://apps.apple.com/us/app/my-virtual-dog-simulator/id1617260958",
    },
    {
      img: Portimga13,
      Discription: "Car Parking 3D: Car Games",
      link: "https://apps.apple.com/us/app/car-parking-3d-car-games/id1586287714",
    },
    {
      img: Portimga14,
      Discription: "Pigeon Bird Simulator",
      link: "https://apps.apple.com/us/app/pigeon-bird-simulator/id6448723758",
    },
  ];
  const PortfolioImage5 = [
    {
      img: Portimga12,
      Discription: "Superhero Fighting Squard",
      link: "https://www.youtube.com/watch?v=_BqOnkNpJvA&list=RDQHJstKwI0Ic&index=27",
    },
  ];
  const PortfolioImage6 = [
    {
      img: Portimga15,
      Discription: "My virtual pet Cat Games",
      link: "https://apps.apple.com/us/app/my-virtual-pet-cat-games/id1606711438",
    },
    {
      img: Portimga16,
      Discription: "Safari dino jurassic monster",
      link: "https://apps.apple.com/us/app/safari-dino-jurassic-monster/id6463721230",
    },
    {
      img: Portimga17,
      Discription: "Bigfoot monster shooting game",
      link: "https://apps.apple.com/us/app/bigfoot-monster-shooting-game/id6502640788",
    },
    {
      img: Portimga18,
      Discription: "Frozen slush maker Rainbow ice",
      link: "https://play.google.com/store/apps/details?id=com.mrbunn.frozen.slush.factory.maker",
    },
  ];
  const PortfolioImage7 = [
    {
      img: Portimga19,
      Discription: "Car Parking 3D: Car Games",
      link: "https://apps.apple.com/us/app/car-parking-3d-car-games/id1586287714",
    },
  ];
  const PortfolioImage8 = [
    {
      img: Portimga27,
      Discription: "Cat Simulator: Family Farm Sim",
      link: "https://apps.apple.com/us/app/cat-simulator-family-farm-sim/id1643099343",
    },
    {
      img: Portimga20,
      Discription: "Fruit Jam dessert bakery game",
      link: "https://play.google.com/store/apps/details?id=com.mrbunn.fruit.jam.factory.games",
    },
    {
      img: Portimga21,
      Discription: "Horse Racing Riding Tables",
      link: "https://apps.apple.com/us/app/horse-racing-riding-tales/id6480463849",
    },
    {
      img: Portimga22,
      Discription: "Wolf game the wild kingdom",
      link: "https://apps.apple.com/us/app/wolf-game-the-wild-kingdom/id6451112651",
    },
  ];
  const PortfolioImage9 = [
    { img: Portimga23, Discription: "Runner Game" },
    { img: Portimga24, Discription: "Truck Racing Game" },
    { img: Portimga25, Discription: "Idle Tailor 3D Game" },
    { img: Portimga26, Discription: "Mouth Picking Bolls Game" },
  ];
  const PortfolioImage10 = [
    {
      img: Portimga28,
      Discription: "Home Fitness Workout App",
      link: "https://apps.apple.com/us/app/home-fitness-workout-app/id6451482943",
    },
    { img: Portimga29 },
    { img: Portimga30 },
    { img: Portimga31 },
  ];
  return (
    <>
      <MainContanier>
        <MainSection>
          <HeadPlusPeera>
            <PortfolioSection data-aos="fade-right">OUR GAMES</PortfolioSection>
            <PortfolioPara>
              Discover the Perfect Game Our Extensive Library of 2D and 3D Games
              on iOS <br></br> and Android - All.Free, Games, and High-Quality,
              with No Waiting!
            </PortfolioPara>
          </HeadPlusPeera>

          <Gellary>
            <GameLinks1>
              {PortfolioImage1.map((image, index) => (
                <Card key={index}>
                  <ClassImage>
                    <CardImage1 src={image.img} alt="Image Not Found" />
                    <Div45>
                      <Bottonref12>
                        {/* <CardDiscription2>{image.Discription}</CardDiscription2> */}
                        <GamesButton12 as="a" href={image.link} target="_blank">
                          <StyledGameControllerIcon />
                          CLICK TO PLAY
                        </GamesButton12>
                        <GamesHeader>{image.Discription}</GamesHeader>
                      </Bottonref12>
                    </Div45>
                  </ClassImage>
                </Card>
              ))}
            </GameLinks1>
            <GameLinks2>
              {PortfolioImage2.map((image, index) => (
                <Card key={index}>
                  <ClassImage>
                    <CardImage src={image.img} alt="Image Not Found" />
                    <Div4>
                      <Bottonref>
                        {/* <CardDiscription2>{image.Discription}</CardDiscription2> */}
                        <GamesButton as="a" href={image.link} target="_blank">
                          <StyledGameControllerIcon1 />
                          CLICK TO PLAY
                        </GamesButton>
                        <GamesHeader1>{image.Discription}</GamesHeader1>
                      </Bottonref>
                    </Div4>
                  </ClassImage>
                </Card>
              ))}
            </GameLinks2>
          </Gellary>

          <Gellary>
            <GameLinks>
              {PortfolioImage3.map((image, index) => (
                <Card key={index}>
                  <ClassImage>
                    <CardImage src={image.img} alt="Image Not Found" />
                    <Div4>
                      <Bottonref>
                        {/* <CardDiscription2>{image.Discription}</CardDiscription2> */}
                        <GamesButton as="a" href={image.link} target="_blank">
                          <StyledGameControllerIcon1 />
                          CLICK TO PLAY
                        </GamesButton>
                        <GamesHeader1>{image.Discription}</GamesHeader1>
                      </Bottonref>
                    </Div4>
                  </ClassImage>
                </Card>
              ))}
            </GameLinks>
          </Gellary>

          <Gellary1>
            <GameLinks1>
              {PortfolioImage4.map((image, index) => (
                <Card key={index}>
                  <ClassImage>
                    <CardImage src={image.img} alt="Image Not Found" />
                    <Div4>
                      <Bottonref>
                        {/* <CardDiscription2>{image.Discription}</CardDiscription2> */}
                        <GamesButton as="a" href={image.link} target="_blank">
                          <StyledGameControllerIcon1 />
                          CLICK TO PLAY
                        </GamesButton>
                        <GamesHeader1>{image.Discription}</GamesHeader1>
                      </Bottonref>
                    </Div4>
                  </ClassImage>
                </Card>
              ))}
            </GameLinks1>
            <GameLinks2>
              {PortfolioImage5.map((image, index) => (
                <Card key={index}>
                  <ClassImage>
                    <CardImage3 src={image.img} alt="Image Not Found" />
                    <Div4>
                      <Bottonref12>
                        {/* <CardDiscription2>{image.Discription}</CardDiscription2> */}
                        <GamesButton12 as="a" href={image.link} target="_blank">
                          <StyledGameControllerIcon />
                          CLICK TO PLAY
                        </GamesButton12>
                        <GamesHeader>{image.Discription}</GamesHeader>
                      </Bottonref12>
                    </Div4>
                  </ClassImage>
                </Card>
              ))}
            </GameLinks2>
          </Gellary1>

          <Gellary>
            <GameLinks>
              {PortfolioImage6.map((image, index) => (
                <Card key={index}>
                  <ClassImage>
                    <CardImage src={image.img} alt="Image Not Found" />
                    <Div4>
                      <Bottonref>
                        {/* <CardDiscription2>{image.Discription}</CardDiscription2> */}
                        <GamesButton as="a" href={image.link} target="_blank">
                          <StyledGameControllerIcon1 />
                          CLICK TO PLAY
                        </GamesButton>
                        <GamesHeader1>{image.Discription}</GamesHeader1>
                      </Bottonref>
                    </Div4>
                  </ClassImage>
                </Card>
              ))}
            </GameLinks>
          </Gellary>

          <Gellary9>
            <GameLinks5>
              {PortfolioImage7.map((image, index) => (
                <Card key={index}>
                  <ClassImage>
                    <CardImage2 src={image.img} alt="Image Not Found" />
                    <Div4>
                      <Bottonref12>
                        {/* <CardDiscription2>{image.Discription}</CardDiscription2> */}
                        <GamesButton12 as="a" href={image.link} target="_blank">
                          <StyledGameControllerIcon />
                          CLICK TO PLAY
                        </GamesButton12>
                        <GamesHeader>{image.Discription}</GamesHeader>
                      </Bottonref12>
                    </Div4>
                  </ClassImage>
                </Card>
              ))}
            </GameLinks5>
            <GameLinks2>
              {PortfolioImage8.map((image, index) => (
                <Card key={index}>
                  <ClassImage>
                    <CardImage src={image.img} alt="Image Not Found" />
                    <Div4>
                      <Bottonref>
                        {/* <CardDiscription2>{image.Discription}</CardDiscription2> */}
                        <GamesButton as="a" href={image.link} target="_blank">
                          <StyledGameControllerIcon1 />
                          CLICK TO PLAY
                        </GamesButton>
                        <GamesHeader1>{image.Discription}</GamesHeader1>
                      </Bottonref>
                    </Div4>
                  </ClassImage>
                </Card>
              ))}
            </GameLinks2>
          </Gellary9>

          <Gellary>
            <GameLinks>
              {PortfolioImage9.map((image, index) => (
                <Card key={index}>
                  <ClassImage>
                    <CardImage src={image.img} alt="Image Not Found" />
                    <Div4>
                      <Bottonref>
                        {/* <CardDiscription2>{image.Discription}</CardDiscription2> */}
                        <GamesButton as="a" href={image.link} target="_blank">
                          <StyledGameControllerIcon1 />
                          CLICK TO PLAY
                        </GamesButton>
                        <GamesHeader1>{image.Discription}</GamesHeader1>
                      </Bottonref>
                    </Div4>
                  </ClassImage>
                </Card>
              ))}
            </GameLinks>
          </Gellary>

          <AppSection>
            <PortfolioSection data-aos="fade-right">OUR APPS</PortfolioSection>
            <PortfolioPara>
              Transform Your Body! Discover the Best Fitness and Health Apps for
              iOS and Android - <br></br>
              Get Instand Acecess to Workout Plans, Healthy Recipes, and More!
            </PortfolioPara>
            <Gellary>
              <GameLinks>
                {PortfolioImage10.map((image, index) => (
                  <Card key={index}>
                    <ClassImage>
                      <CardImage src={image.img} alt="Image Not Found" />
                      <Div4>
                        <Bottonref>
                          {/* <CardDiscription2>{image.Discription}</CardDiscription2> */}
                          <GamesButton as="a" href={image.link} target="_blank">
                            <StyledGameControllerIcon1 />
                            CLICK TO RUN
                          </GamesButton>
                          <GamesHeader1>{image.Discription}</GamesHeader1>
                        </Bottonref>
                      </Div4>
                    </ClassImage>
                  </Card>
                ))}
              </GameLinks>
            </Gellary>
          </AppSection>
        </MainSection>
      </MainContanier>
    </>
  );
};

export default GamePortfolio;
